import { PresenceAgentV2 } from 'apis/presence';

import { ajaxSend } from '../../../api/api';

const baseV2 = '/v2/presence';

export type PresenceQueryParams = {
  search?: string;
  offset?: number;
  limit?: number;
  filter?: string;
};

export type PresenceGetAllResponse = {
  data: {
    presence: Array<PresenceAgentV2>;
  };
  meta: {
    next_page: string | null;
    prev_page: string | null;
  };
};

export type PresenceTotalResponse = {
  data: {
    total: number;
  };
};

export function presenceGetTotal(params: PresenceQueryParams = {}) {
  return ajaxSend<PresenceTotalResponse>({
    params,
    path: `${baseV2}/total`,
  });
}

export function presenceGetAll(params: PresenceQueryParams = {}) {
  return ajaxSend<PresenceGetAllResponse>({
    params,
    path: baseV2,
  });
}
